if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"corksyAdmin","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(089|315|47)|4(3(53|87|97)|168|407|421|999)|5(37[24]|576|965)|6(013|127|516|68|86)|7(041|396|798|895)|1169|1291|3293|3915|8244|8779|94)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}